import { ADD_AGENT_USER, EDIT_AGENT_USER, GET_AGENT_USER } from "../constants/action-types";

const initilState = {
  state: "",
};

const agentUserReducer = (state = initilState, action) => {
  switch (action.type) {
    case ADD_AGENT_USER:
      return {
        ...state,
        ...state.data.push(action?.payload),
      };
    case GET_AGENT_USER:
      return {
        ...state,
        data: action.payload,
      };
    case EDIT_AGENT_USER:
      const index = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(index, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };

    default:
      return state;
  }
};

export default agentUserReducer;
